"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterBar = void 0;
var lodash_1 = require("lodash");
var React = require("react");
var AddFilterButton_1 = require("./components/AddFilterButton");
var SelectFilterDropdown_1 = require("./components/SelectFilterDropdown");
var FilterBar_context_1 = require("./FilterBar.context");
var FilterBar_styles_1 = require("./FilterBar.styles");
var initialValue = function (allAvailableFilters, value) {
    var activeFilters = [];
    if (value) {
        value.forEach(function (saved) {
            var item = allAvailableFilters.find(function (filterItem) { return filterItem.Name === saved.Name; });
            if (item) {
                item.Value = saved.Value;
                activeFilters.push(item);
            }
        });
        return activeFilters;
    }
    return [];
};
exports.FilterBar = React.forwardRef(function (_a, ref) {
    var children = _a.children, OnFilterTypeAdd = _a.OnFilterTypeAdd, OnChange = _a.OnChange, Value = _a.Value, Disabled = _a.Disabled;
    var allAvailableFilters = React.Children.map(children, function (child) { return ({
        Multiple: child.props.Type === "MultipleSelect",
        Name: child.props.Name,
    }); });
    var _b = React.useState(initialValue(allAvailableFilters, Value)), activeFilters = _b[0], setActiveFilters = _b[1];
    React.useImperativeHandle(ref, function () { return ({
        clearFilters: function () {
            setActiveFilters([]);
        },
    }); });
    var handleAddNewFilter = function (filter) {
        var item = allAvailableFilters.find(function (filterItem) { return filterItem.Name === filter.Name; });
        item.ShowOptions = true;
        activeFilters.push(item);
        setActiveFilters(__spreadArray([], activeFilters));
    };
    var handleSelect = function (filter, value) {
        if (value && value.length) {
            // we have some values
            var item = activeFilters.find(function (filterItem) { return filterItem.Name === filter.Name; });
            item.ShowOptions = false;
            item.Value = value;
            setActiveFilters(__spreadArray([], activeFilters));
            fireOnChangeEvent(__spreadArray([], activeFilters));
        }
        else {
            // we dont have any values so remove this item
            var filters = lodash_1.remove(activeFilters, function (e) { return e.Name !== filter.Name; });
            setActiveFilters(__spreadArray([], filters));
            fireOnChangeEvent(__spreadArray([], filters));
        }
    };
    var handleRemove = function (filter) {
        var itemIndex = activeFilters.findIndex(function (filterItem) { return filterItem.Name === filter.Name; });
        activeFilters.splice(itemIndex, 1);
        setActiveFilters(__spreadArray([], activeFilters));
        fireOnChangeEvent(__spreadArray([], activeFilters));
    };
    var fireOnChangeEvent = function (filters) {
        if (filters === void 0) { filters = activeFilters; }
        var currentValues = filters
            .map(function (e) {
            if (e.Value) {
                return {
                    Name: e.Name,
                    Value: e.Value,
                };
            }
        })
            .filter(function (e) { return e; });
        OnChange(currentValues);
    };
    return (React.createElement(FilterBar_context_1.FilterBarContext.Provider, { value: {
            FilterTypes: allAvailableFilters,
            HasFilters: activeFilters.filter(function (filter) { return filter.Value; }).length > 0,
            DoesItemHaveValue: function (name) {
                return activeFilters.find(function (filter) { return filter.Name === name; }) !== undefined;
            },
            OnFilterTypeAdd: OnFilterTypeAdd,
        } },
        React.createElement(FilterBar_styles_1.WrapperDiv, null,
            activeFilters &&
                activeFilters.map(function (filter) { return (React.createElement(SelectFilterDropdown_1.SelectFilterDropdown, { key: filter.Name, OnRemove: handleRemove, OnSelected: handleSelect, Filter: filter })); }),
            React.createElement("div", null,
                React.createElement(AddFilterButton_1.AddFilterButton, { OnFilterTypeClick: handleAddNewFilter, Disabled: Disabled })))));
});
